import React from 'react';
import { Chip } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const usePercentageChipStyles = makeStyles()(theme => ({
  root: {
    height: '24px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 400,
  },
  negative: {
    backgroundColor: theme.palette.success.background,
  },
  positive: {
    backgroundColor: theme.palette.error.background,
  },
  zero: {
    backgroundColor: theme.palette.info.background,
  },
}));


export const PercentageChip: React.FC<{ value: number }> = ({ value }) => {
  const {
    classes: {
      negative,
      positive,
      zero,
      ...classes
    }
  } = usePercentageChipStyles();

  if (value > 0) {
    return (
      <Chip className={positive} classes={classes} label={`+${value}%`} />
    );
  }

  if (value < 0) {
    return (
      <Chip className={negative} classes={classes} label={`${value}%`} />
    );
  }

  return (
    <Chip className={zero} classes={classes} label={`±${value}%`} />
  );
};
